export const iconFontAwesomeMathematicsPlus = (
	<i className="fa-solid fa-plus"></i>
);
